import { Create, SimpleForm, TextInput } from 'react-admin';

export const TagCreate = () => (
	<Create>
		<SimpleForm>
			<TextInput source="name" />
		</SimpleForm>
	</Create>
);
